import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonNonPlayActionIos.module.scss";

export interface ISongDetailsLessonNonPlayActionIosProps {
}

export const SongDetailsLessonNonPlayActionIos: VoidFunctionComponent<ISongDetailsLessonNonPlayActionIosProps> = ({}) => {
  return (
    <div className={s.container}>
      <div className={s.prompt} >Get songs on our website!</div>
    </div>
  );
}

